import { Box, Image, Badge, Table, Thead, Tbody, Tr, Th, Td, TableContainer, Center, Spinner, Flex, Text } from '@chakra-ui/react';
import MyDiv from './upcomingInterviewsCard.style'
import ArrowIcon from "../../../../../assets/images/ActionArrow.svg";
import { useNavigate } from "react-router";
import * as routesNames from '../../../../../constants/routes';
import { CustomPagination, CustomTable, CustomToast } from '../../../../../components';
import { ILazyParams, useFetch } from '../../../../../hooks/useFetch';
import { useEffect, useState } from 'react';
import { Column } from '../../../../../components/CustomTable/customTable';
import { showDate } from '../../../../../utilities/helper';

const UpcomingInterviewsCard = () => {
  const { addToast } = CustomToast();
  const { fetchApi, loading } = useFetch(addToast);
  const navigate = useNavigate();
  const [upcomingInterviews, setUpcomingInterviews] = useState<any[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [query, setQuery] = useState<{ lazyParams: ILazyParams, }>({ lazyParams: { first: 0, rows: 20, page: 0, sortField: '', sortOrder: 1, }, });


  const pageCount = Math.ceil(totalCount / query.lazyParams.rows);

  const handlePageClick = ({ selected }: { selected: number }) => {
    setQuery(prev => {
      const updatedParams = {
        ...prev.lazyParams,
        page: selected,
        first: selected * prev.lazyParams.rows,
      };
      return { ...prev, lazyParams: updatedParams };
    });
  };

  const setRowsPerPage = (rows: number) => {
    setQuery((prev) => {
      const updatedParams = {
        ...prev.lazyParams,
        rows,
        page: 0,
        first: 0,
      };
      return { ...prev, lazyParams: updatedParams };
    });
  };


  const candidateDetails = (candidate: any) => {
    navigate(routesNames.CANDIDATEDETAILS, { state: { candidate_Id: candidate.id, candidate_Name: candidate.candidate_Name, job_Profile: candidate.job_Profile_Name, jobId: candidate.jobId } });
  };

  const loadUpcomingInterviews = async () => {

    const response = await fetchApi("RecruitmentDashboard/UpcomingInterviews", "GET", "", `lazyParams=${JSON.stringify(query.lazyParams)}`, "");
    if (response) {
      setUpcomingInterviews(response.data);
      setTotalCount(response.totalCount);
    }
  }

  useEffect(() => {
    loadUpcomingInterviews();
  }, [query.lazyParams]);

  return (
    <MyDiv>
      <Box>
        <Box position="relative" minH="300px">
          {loading ? (
            <Center position="absolute" top={0} left={0} right={0} bottom={0}>
              <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
            </Center>) : (
            <>
              <CustomTable value={upcomingInterviews} >
                <Column header="S. No" body={(_, index) => index + 1} />
                <Column
                  header="Job Title"
                  body={(row: any) => (
                    <Badge
                      variant="subtle"
                      className="job font-poppins text_sm text_regular"
                      onClick={() => candidateDetails(row)}
                    >
                      {row.job_Profile_Name}
                    </Badge>
                  )}
                />

                <Column header="Candidate Name" field="candidate_Name" />
                <Column header="Payroll Company" field="payroll_Company_Name" />
                <Column header="Branch" field="branch_Name" />
                <Column header="Department" field="department_Name" />
                <Column header="Interview Mode" field="interview_Mode" />
                <Column header="Interview Date" field="interview_Date" body={r => showDate(r.interview_Date)} />
                <Column header="Interview Time" field="interview_Time" />
                <Column header="Created By" field="createdBy" />
                <Column
                  header="Action"
                  body={(row: any) => (
                    <Image src={ArrowIcon} alt="Action" cursor="pointer" onClick={() => candidateDetails(row)} />
                  )}
                />
              </CustomTable>

            </>)}
        </Box>
        <CustomPagination pageCount={pageCount} handlePageClick={handlePageClick} rowsPerPage={query.lazyParams.rows} setRowsPerPage={setRowsPerPage} totalRecords={totalCount} currentPage={query.lazyParams.page} />
      </Box>

    </MyDiv>
  )
}

export default UpcomingInterviewsCard;
